import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

// Service worker management:
// The PWA SW is ONLY useful for the admin panel and portal pages.
// On public pages the SW MUST be fully unregistered because it intercepts
// cross-origin Unsplash image fetches, returning opaque/empty responses
// that break companion gallery images on subsequent page loads.
const isAdminOrPortal =
  window.location.pathname.startsWith("/admin") ||
  window.location.pathname.startsWith("/portal");

if ("serviceWorker" in navigator) {
  if (isAdminOrPortal) {
    // Register SW only on admin/portal pages
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" });
    });
  } else {
    // CRITICAL: On public pages, unregister ALL service workers immediately
    // and purge every cache to ensure clean Unsplash image loading.
    // This runs BEFORE React mounts to win the race against registerSW.js.
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((r) => r.unregister());
    });
    if ("caches" in window) {
      caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
    }
    // Also prevent the VitePWA-generated registerSW.js from re-registering
    // by overriding the load handler it sets up
    navigator.serviceWorker.register = (() => Promise.reject("SW disabled on public pages")) as any;
  }
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
